module.exports = __webpack_public_path__ + "media/resumes_and_cover_letters/resumes-and-cover-letters_title-94e9490c.png";